<dx-tooltip
  target="{{ tooltipData.target }}"
  position="bottom"
  [visible]="tooltipData.isHidden"
  [hideOnOutsideClick]="false"
>
  <div class="tooltipLayout">
    <div class="frameLayout">
      <div class="subtitle">{{ tooltipData.fittingName }}</div>
      <div class="content-container">
        <div class="contentLayout">
          @for (item of tooltipData.tooltipItems; track item) {
            <div class="itemLayout">
              <div class="fitItemheader">{{ item.header }}</div>
              <div class="fitItem">
                @if (getHtmlContent(item).templateName === 'default') {
                  <div>
                    {{ getHtmlContent(item).data[0] }}
                  </div>
                }
                @if (getHtmlContent(item).templateName === 'size') {
                  <div>
                    <div class="size-content">
                      @for (d of item.valueAsArray; track d; let isLast = $last; let isFirst = $first) {
                        <span
                          class="size-line"
                          [ngClass]="isFirst ? 'firstLine' : endsWith(d) ? 'darkGraySpace' : 'preSpace'"
                        >
                          {{ slice(d, isLast) }}
                        </span>
                      }
                    </div>
                  </div>
                }
                @if (getHtmlContent(item).templateName === 'color') {
                  <div>
                    <div class="service-color-content" [style.background-color]="'rgb(' + item.value + ')'"></div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</dx-tooltip>
